import { memo, Suspense } from 'react';
import DropdownList from '@/components/DropdownList';
import { ErrorBoundary } from 'react-error-boundary';
import { Terms, TermsCategory } from '@/api/terms.types';
import useLatestTermsContentUrl from '@/features/apply-event/hooks/useLatestTermsContentUrl';
import { useDisclosure } from '@/components/Disclosure/Disclosure';

type PropTypes = {
  data: Terms[];
  state: Record<TermsCategory, boolean>;
  onChangeState: (category: TermsCategory, value: boolean) => void;
};

type ItemPropTypes = {
  title: string;
  category: TermsCategory;
  value: boolean;
  onChangeValue: (value: boolean) => void;
};

const Agreements = ({ data, state, onChangeState }: PropTypes) => {
  return data.map((terms) => (
    <Item
      key={terms.category}
      title={terms.title}
      category={terms.category}
      value={state[terms.category]}
      onChangeValue={(value) => onChangeState(terms.category, value)}
    />
  ));
};

const Item = memo(
  ({ title, category, value, onChangeValue }: ItemPropTypes) => (
    <DropdownList
      type="with-check"
      title={title}
      checked={value}
      onChangeChecked={onChangeValue}
    >
      <Content category={category} />
    </DropdownList>
  ),
  (prev, next) => {
    return (
      prev.value === next.value &&
      prev.category === next.category &&
      prev.title === next.title
    );
  },
);

const Content = memo(({ category }: Pick<ItemPropTypes, 'category'>) => {
  const { value } = useDisclosure();
  const url = useLatestTermsContentUrl(category, value);

  return <DropdownList.Iframe src={url} />;
});

export default Agreements;
